//CORE
import React from "react";
import PropTypes from "prop-types";
//COMPONENTS
import { Dialog, DialogContent, DialogActions } from "@material-ui/core";
import AppBarModal from "../general/AppBarModal";
import { BtnForm } from "../general/BotonesAccion";
import HorarioCalendario from "./HorarioCalendario";

const ListarHorario = ({ status, toggle, data, cargando }) => {
  return (
    <Dialog
      open={status}
      onClose={() => toggle({ modal: "dialogHorario", value: false })}
      aria-labelledby="form-dialog-title"
      fullWidth={true}
      maxWidth="md"
    >
      <AppBarModal
        titulo="Horario"
        mostrarModal={() => toggle({ modal: "dialogHorario", value: false })}
        titulo_accion=""
        accion=""
      />
      <DialogContent style={{ padding: 0 }} className="scroll">
        <HorarioCalendario data={data} cargando={cargando} />
      </DialogContent>
      <DialogActions>
        <BtnForm
          texto="Cerrar"
          callback={() => toggle({ modal: "dialogHorario", value: false })}
        />
      </DialogActions>
    </Dialog>
  );
};

ListarHorario.protoTypes = {
  status: PropTypes.bool,
  toggle: PropTypes.func,
  data: PropTypes.array,
  cargando: PropTypes.bool,
};

export default ListarHorario;
